import React, { useContext, useState } from 'react';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import { getCookie, getLocalStorageItem } from '../utils/Utils';
import SelectVendor from '../components/vendor/SelectVendor'
import { AuthContext } from '../Context/authContext';
import { useNavigate } from 'react-router-dom';

const SignoutHandler = ({ user }) => {
  const { t } = useTranslation();
  const { Signout, NAME, EMAIL, ROLE, CPIOFFICE, SwitchVendor } = t('userprofile');
  const userDataArray = JSON.parse(localStorage.getItem("userDataArray"))
  const { sendEvent } = useContext(AuthContext);
  const vendorRole = getCookie('role') === 'vendor';
  const [showSelectVendor, setShow] = useState(false);
  const navigate = useNavigate();
  
  const handleSignout = () => {
    try {
      sendEvent("LOGOUT");
    } catch (e) {
      console.error("Logout event error:", e);
    }
    const tokenId = getCookie('idcs_id_token');
    const roleCookie = getCookie('role');
    const roleStorage = getLocalStorageItem('role');
    const role = roleCookie || roleStorage;
    if (!tokenId || !role) {
      if (role) {
        // Redirect to intermediate page
        navigate('/refresh-login', { state: { role } })
      } else {
        navigate('/session-timeout')
      }
      return
    }

    const baseUrl = process.env.REACT_APP_ANOTHER_API_URL;
    const isDev = process.env.NODE_ENV === "development";
    
    let logoutUrl = isDev
      ? `${baseUrl}/logout?port=${window.location.port}&role=${role}`
      : `${baseUrl}/logout?role=${role}`;

    if (tokenId) {
      logoutUrl += `&token-id=${tokenId}`;
    }

    clearLocalStorage();
    removeCookies();

    window.location.replace(logoutUrl);
  };

  const clearLocalStorage = () => {
    try {
      localStorage.clear();
      sessionStorage.clear();
    } catch (e) {
      console.error("Error clearing storage:", e);
    }
  };

  const removeCookies = () => {
    Cookies.remove('idcs_user_assertion', { path: '/' });
    Cookies.remove('idcs_refresh_token', { path: '/' });
    Cookies.remove('idcs_id_token', { path: '/' });
    Cookies.remove('role', { path: '/' });
    Cookies.remove('returnUrl', { path: '/' });
  };

  return (
    <>
      <div className=' '>
        {
          user &&
          <div className='space-y-3 p-3 text-md duration-1000'>
            <div className='flex gap-2 '>
              <span className='font-bold'>{NAME} - </span>
              <p >
                {user?.roleName === 'SUPPLIER_ROLE' 
                  ? `${user?.supplierName} - ${user?.supplierId}`
                  : user?.fullName}
              </p>
            </div>
            <div className='flex gap-2 '>
              <span className='font-bold'>{EMAIL} - </span>
              <p className=' uppercase '>
                {user?.email}
              </p>
            </div>
            <div className='gap-2 flex'>
              <span className='font-bold'>{ROLE} - </span>
              <p >
                {user?.userGroupName}
              </p>
            </div>
            {user?.userGroupName === "OVERSEAS_ROLE" && <div className='gap-2 flex'>
              <span className='font-bold'>{CPIOFFICE} - </span>
              <p >
                {user?.roleType}
              </p>
            </div>}

          </div>
        }
        <div className="flex w-full items-center my-1">
          {vendorRole && userDataArray?.length > 1 && (
            <button
              className="text-blue-500 text-sm cursor-pointer"
              onClick={() => setShow(true)}
            >
             {SwitchVendor} 
            </button>
          )}

          <button
            className="text-blue-500 underline text-sm cursor-pointer ml-auto"
            onClick={handleSignout}
          >
            {Signout}
          </button>
        </div>

      </div >
      {showSelectVendor && <SelectVendor isOpen={showSelectVendor} onCancel={() => setShow(false)} />
      }
    </>
  )
}

export default SignoutHandler
